export const DEFAULT_MENU_CATEGORIES = [
  {
    name: "Plato Principal",
    icon: "PP",
    subcategories: ["Pastas", "Entre Panes", "Ensaladas", "Sopas"],
  },
  {
    name: "Entradas",
    icon: "EN",
    subcategories: ["Clasicas", "Para compartir"],
  },
  {
    name: "Desayuno/Merienda",
    icon: "DM",
    subcategories: ["Cafe", "Tostados", "Pasteleria"],
  },
  {
    name: "Postres",
    icon: "PO",
    subcategories: ["Tortas", "Helados"],
  },
  {
    name: "Bebidas",
    icon: "BE",
    subcategories: ["Sin alcohol", "Con alcohol"],
  },
];

export const buildCategoryIcon = (name, fallback = "CT") => {
  const trimmed = (name || "").trim();
  if (!trimmed) {
    return fallback;
  }

  return trimmed
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0] || "")
    .join("")
    .toUpperCase()
    .slice(0, 2);
};
